var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _rect, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirewallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 121,
    viewBox: "0 0 476 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.947 60.4324V70.198H259.369L249.033 114.235H228.168L225.329 98.4442L223.207 86.5909L220.271 70.2541H219.43L216.509 86.5909L214.373 98.4442L211.547 114.235H190.765L189.8 110.115H196.484V101.681H187.829L178.21 60.4324H188.808V53.8752H193.563L201.446 97.4214H202.3L210.018 53.8752H230.621L238.339 97.4214H239.111L247.159 53.8752H263.187L261.657 60.4324H252.947Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.676 62.2539H293.905V53.8754H278.842L267.21 89.8416H268.313V107.061H261.656L259.341 114.235H276.637L279.6 103.46H299.79L302.753 114.235H320.476L303.676 62.2539ZM283.155 90.5141L289.261 68.0965H290.101L296.206 90.5141H283.142H283.155Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372.128 99.1449V114.235H328.868V78.2965H334.849V67.8864H328.868V53.8754H339.204V56.7897H345.833V99.1449H356.39V101.947H366.63V99.1449H372.128Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M420.723 107.117V114.235H404.364V111.615H382.893V114.235H377.463V86.759H382.893V78.0862H377.463V57.6162H382.865V53.8752H394.428V58.2187H384.602V72.4118H394.428V99.1448H414.328V107.117H420.723Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M382.891 78.0865H369.551V86.7593H382.891V78.0865Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404.362 111.615H382.891V120.288H404.362V111.615Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M382.862 48.9435H361.391V57.6163H382.862V48.9435Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M271.8 62.5341H259.328V68.0964H271.8V62.5341Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312.029 34.6523H296.222V44.5441H312.029V34.6523Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.321 47.8929H342.003V53.2732H349.321V47.8929Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M439.271 94.4791H422.086V102.676H439.271V94.4791Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.918 34.6523H267.061V40.607H272.918V34.6523Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M424.649 75.172H415.126V80.6083H424.649V75.172Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5977 120.288L50.714 51.7178H67.0451L65.9288 120.288H49.5977Z",
    fill: "#FCFBFB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.869 68.3207V77.708H162.073V82.4858H166.359V88.8187H141.869V99.8594H169.625V115.496L125.552 113.142V55.0523L145.88 53.8893V59.3536H159.454V53.1047L169.625 52.5303V68.3207H141.869Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.812 77.8482C120.12 72.538 122.242 59.0314 122.242 59.0314C122.242 59.0314 114.221 64.888 115.337 59.4518C116.426 54.1136 119.582 48.0048 119.678 47.8226C119.582 47.8927 116.619 50.1064 109.604 51.8998C106.917 52.5864 103.375 52.8946 100.026 53.0067C94.4859 53.1888 89.4281 52.8666 89.4281 52.8666H72.4492V114.151L87.9397 116.392V89.6314H94.4445L103.237 116.392L119.692 114.151L108.86 87.1094C112.733 85.1199 115.475 81.9814 116.826 77.8762L116.812 77.8482ZM95.299 84.2232H87.9397V71.235H95.299C99.5575 71.235 102.272 73.6029 102.272 77.7641C102.272 81.9254 99.5575 84.2232 95.299 84.2232Z",
    fill: "#FCFBFB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8081 57.2521C47.8081 57.2521 46.8021 71.165 43.6736 71.5713H16.3173V82.612H41.2205V94.6474H16.3173V118.746L0 116.378V58.2889C0 58.2889 0 58.2889 0.027563 58.2889C1.07496 58.1348 34.4538 53.1189 39.1395 51.7178C43.8941 50.3026 45.8925 49.3079 45.8925 49.3079C45.8925 49.3079 43.8252 53.7914 43.1775 57.6864C42.5298 61.5815 47.8081 57.2661 47.8081 57.2661V57.2521Z",
    fill: "#FCFBFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M252.947 60.4324V70.198H259.369L249.033 114.235H228.168L225.329 98.4442L223.207 86.5909L220.271 70.2541H219.43L216.509 86.5909L214.373 98.4442L211.547 114.235H190.765L189.8 110.115H196.484V101.681H187.829L178.21 60.4324H188.808V53.8752H193.563L201.446 97.4214H202.3L210.018 53.8752H230.621L238.339 97.4214H239.111L247.159 53.8752H263.187L261.657 60.4324H252.947Z",
    fill: "url(#paint0_linear_270_1214)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M303.676 62.2539H293.905V53.8754H278.842L267.21 89.8416H268.313V107.061H261.656L259.341 114.235H276.637L279.6 103.46H299.79L302.753 114.235H320.476L303.676 62.2539ZM283.155 90.5141L289.261 68.0965H290.101L296.206 90.5141H283.142H283.155Z",
    fill: "url(#paint1_linear_270_1214)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M372.128 99.1449V114.235H328.868V78.2965H334.849V67.8864H328.868V53.8754H339.204V56.7897H345.833V99.1449H356.39V101.947H366.63V99.1449H372.128Z",
    fill: "url(#paint2_linear_270_1214)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M420.723 107.117V114.235H404.364V111.615H382.893V114.235H377.463V86.759H382.893V78.0862H377.463V57.6162H382.865V53.8752H394.428V58.2187H384.602V72.4118H394.428V99.1448H414.328V107.117H420.723Z",
    fill: "url(#paint3_linear_270_1214)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M382.891 78.0865H369.551V86.7593H382.891V78.0865Z",
    fill: "url(#paint4_linear_270_1214)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M404.362 111.615H382.891V120.288H404.362V111.615Z",
    fill: "url(#paint5_linear_270_1214)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M382.862 48.9435H361.391V57.6163H382.862V48.9435Z",
    fill: "url(#paint6_linear_270_1214)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M271.8 62.5341H259.328V68.0964H271.8V62.5341Z",
    fill: "url(#paint7_linear_270_1214)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M312.029 34.6523H296.222V44.5441H312.029V34.6523Z",
    fill: "url(#paint8_linear_270_1214)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M349.321 47.8929H342.003V53.2732H349.321V47.8929Z",
    fill: "url(#paint9_linear_270_1214)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M439.271 94.4791H422.086V102.676H439.271V94.4791Z",
    fill: "url(#paint10_linear_270_1214)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M272.918 34.6523H267.061V40.607H272.918V34.6523Z",
    fill: "url(#paint11_linear_270_1214)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M424.649 75.172H415.126V80.6083H424.649V75.172Z",
    fill: "url(#paint12_linear_270_1214)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5977 120.288L50.714 51.7178H67.0451L65.9288 120.288H49.5977Z",
    fill: "url(#paint13_linear_270_1214)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.869 68.3207V77.708H162.073V82.4858H166.359V88.8187H141.869V99.8594H169.625V115.496L125.552 113.142V55.0523L145.88 53.8893V59.3536H159.454V53.1047L169.625 52.5303V68.3207H141.869Z",
    fill: "url(#paint14_linear_270_1214)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M116.812 77.8482C120.12 72.538 122.242 59.0314 122.242 59.0314C122.242 59.0314 114.221 64.888 115.337 59.4518C116.426 54.1136 119.582 48.0048 119.678 47.8226C119.582 47.8927 116.619 50.1064 109.604 51.8998C106.917 52.5864 103.375 52.8946 100.026 53.0067C94.4859 53.1888 89.4281 52.8666 89.4281 52.8666H72.4492V114.151L87.9397 116.392V89.6314H94.4445L103.237 116.392L119.692 114.151L108.86 87.1094C112.733 85.1199 115.475 81.9814 116.826 77.8762L116.812 77.8482ZM95.299 84.2232H87.9397V71.235H95.299C99.5575 71.235 102.272 73.6029 102.272 77.7641C102.272 81.9254 99.5575 84.2232 95.299 84.2232Z",
    fill: "url(#paint15_linear_270_1214)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8081 57.2521C47.8081 57.2521 46.8021 71.165 43.6736 71.5713H16.3173V82.612H41.2205V94.6474H16.3173V118.746L0 116.378V58.2889C0 58.2889 0 58.2889 0.027563 58.2889C1.07496 58.1348 34.4538 53.1189 39.1395 51.7178C43.8941 50.3026 45.8925 49.3079 45.8925 49.3079C45.8925 49.3079 43.8252 53.7914 43.1775 57.6864C42.5298 61.5815 47.8081 57.2661 47.8081 57.2661V57.2521Z",
    fill: "url(#paint16_linear_270_1214)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 383.125,
    y: 0.507324,
    width: 53.7479,
    height: 7.00549,
    fill: "url(#paint17_linear_270_1214)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 350.052,
    y: 24.3262,
    width: 30.3193,
    height: 11.2088,
    fill: "url(#paint18_linear_270_1214)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 420.336,
    y: 71.9634,
    width: 30.3193,
    height: 5.6044,
    fill: "url(#paint19_linear_270_1214)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 431,
    y: 21.0845,
    width: 45,
    height: 5,
    fill: "url(#paint20_linear_270_1214)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 399.666,
    y: 38.3369,
    width: 15.1597,
    height: 7.00549,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_270_1214",
    x1: 0.00109243,
    y1: 52.7544,
    x2: 439.273,
    y2: 52.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_270_1214",
    x1: 0.000150731,
    y1: 52.7545,
    x2: 439.272,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_270_1214",
    x1: -0.000152183,
    y1: 52.7545,
    x2: 439.272,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_270_1214",
    x1: 0.000957565,
    y1: 52.7544,
    x2: 439.273,
    y2: 52.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_270_1214",
    x1: -0.000470265,
    y1: 52.7547,
    x2: 439.271,
    y2: 52.7547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_270_1214",
    x1: -0.00179404,
    y1: 52.7545,
    x2: 439.271,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_270_1214",
    x1: -0.00193523,
    y1: 52.7545,
    x2: 439.27,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_270_1214",
    x1: 0.00112488,
    y1: 52.7544,
    x2: 439.274,
    y2: 52.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_270_1214",
    x1: 0.00161185,
    y1: 52.7545,
    x2: 439.274,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_270_1214",
    x1: 0.000818641,
    y1: 52.7548,
    x2: 439.273,
    y2: 52.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_270_1214",
    x1: -0.000765994,
    y1: 52.7544,
    x2: 439.272,
    y2: 52.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_270_1214",
    x1: 0.00221246,
    y1: 52.7545,
    x2: 439.274,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_270_1214",
    x1: -0.00126261,
    y1: 52.7544,
    x2: 439.271,
    y2: 52.7544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_270_1214",
    x1: -0.00204274,
    y1: 52.7546,
    x2: 439.27,
    y2: 52.7546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_270_1214",
    x1: 0.00208243,
    y1: 52.7545,
    x2: 439.274,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_270_1214",
    x1: -0.000243254,
    y1: 52.7545,
    x2: 439.272,
    y2: 52.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_270_1214",
    x1: 0,
    y1: 52.7546,
    x2: 439.272,
    y2: 52.7546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#03FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_270_1214",
    x1: 383.125,
    y1: 4.01007,
    x2: 436.873,
    y2: 4.01007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_270_1214",
    x1: 350.052,
    y1: 29.9306,
    x2: 380.371,
    y2: 29.9306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_270_1214",
    x1: 420.336,
    y1: 74.7656,
    x2: 450.655,
    y2: 74.7656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_270_1214",
    x1: 431,
    y1: 23.5845,
    x2: 476,
    y2: 23.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirewallLogo);
export default __webpack_public_path__ + "static/media/firewall_logo.cfbd55edbe05f09309a3158d4a86b82d.svg";
export { ForwardRef as ReactComponent };